import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createLoginRequest, otoVerification, resendemailotpRequest, resendotpRequest } from "../../../actions/loginAction";
import {validateInput} from "../../Validations/Signin";
import {ToastsContainer, ToastsStore, ToastsContainerPosition} from 'react-toasts';
import { bindActionCreators } from 'redux';
import { withRouter } from "react-router-dom";
import pathList from "../../../helpers/pathList";
import VerifyOtp from "../otpverify";
import PaymentOption from "./paymentoption";
import WalletConnection from "../../Promotion/PromotionBody/walletconnection";
import { evcwalletPayment } from "../../../actions/evcAction";
import { getlanguagelist } from "../../../helpers/changelanguage";
import { registerVersion } from 'firebase';
import $ from 'jquery';
import firebase from '../../../../src/config';


class Form extends Component {
  constructor(props){
    super(props);
    this.state = {
      username          : '',
      password          : '',
      language          : 'en',
      otpmodal          : false,
      paymentoptmodal   : false,
      evcmodal          : false,
      membership        : 'BASIC',
      user_id           : null,
      is_phone_verified : 0,
      is_email_verified : 0,
      visibility        : 'hidden',
      phone             : '',
      email             : '',
      fcm_token         : ''
    };
    this.onSubmit               = this.onSubmit.bind(this);
    this.handleChange           = this.handleChange.bind(this);
    this.onOtpClose             = this.onOtpClose.bind(this);
    this.onOtpSubmit            = this.onOtpSubmit.bind(this);
    this.resend                 = this.resend.bind(this);
    this.onPaymentoptSubmit     = this.onPaymentoptSubmit.bind(this);
    this.onPaymentoptmodelOpen  = this.onPaymentoptmodelOpen.bind(this);
    this.onPaymentoptmodelClose = this.onPaymentoptmodelClose.bind(this);
    this.closeevcModal          = this.closeevcModal.bind(this);
    this.openevcModal           = this.openevcModal.bind(this);
    this.evcpayment             = this.evcpayment.bind(this);
  }
  componentDidMount() {
 
  }
  onSubmit(e){
    e.preventDefault();
    if(firebase.messaging.isSupported()) {
      console.log(13);
      const  messaging = firebase.messaging();
      messaging
      .requestPermission()
      .then(() => {
        return messaging.getToken();
      })
      .then(token => {
        this.setState({
          fcm_token    : token,
        })
        this.loginUser();
      })
      .catch(error => {
        if (error.code === "messaging/permission-blocked") {
            console.log("Please Unblock Notification Request Manually");
        } else {
            console.log("Error Occurred", error);
        }
        this.loginUser();
      }); 
    }else{
        console.log('not supporting Firebase Javascript SDK');
        this.loginUser();
    }
    
  };

  loginUser(){
   // console.log('State :: ', this.state);
    const { error, isValid } = validateInput(this.state);
    if (isValid) {
      this.props.createLoginRequest(this.state).then( loginRes => {
        if(loginRes.user.req_status == true){
          if(loginRes.user.membership_upgrade_status == "GOLD PENDING"){
            window.location.reload();
          }else if(loginRes.user.membership_upgrade_status == "GOLD REJECTED"){
            window.location.reload();
          }else if(loginRes.user.membership_upgrade_status == "GOLD APPROVED"){
           // window.location.href = loginRes.user.payment_url; 
           this.onPaymentoptmodelOpen();
          }else{
            localStorage.setItem('login', 1);
            this.props.history.push(pathList.feed.path);
          }
          
        }else{
          ToastsStore.error(loginRes.user.req_message);
          this.setState({
            isLoading         : false,
            membership        : loginRes.user.membership_upgrade_status == 'GOLD PENDING' ? 'GOLD' : loginRes.user.membership,
            user_id           : loginRes.user.id,
            is_phone_verified : loginRes.user.is_phone_verified,
            phone             : loginRes.user.phone, 
            is_email_verified : loginRes.user.is_email_verified,
            email             : loginRes.user.email,  
          },function(){
            
            if(this.state.is_phone_verified == 0){
              this.setState({
                otpmodal    : true,
              })
            }
          });
        }
        
      },
      err => {
        console.log(err);
      })
    }else {
      ToastsStore.error(error.message)
      this.setState({
        isLoading: false,
      });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps,prevProps){
    if(nextProps.otp != this.props.otp)
    {
      if(nextProps.otp.req_status == true){
          ToastsStore.success(nextProps.otp.req_message);
          this.setState({
            otpmodal    : false
          })
        if(this.state.membership == 'BASIC'){
          this.props.history.push(pathList.feed.path);
        }else{
          //thank u popup
          let curlang = (localStorage.getItem('userLanguage') == undefined) ? 'so' : 'en';
          if(curlang == 'en'){
            $("#thanku").html('<h2>Thank You</h2><span>for your submission.</span><div class="clr25"></div><p>Your account is pending for approval from <br/>Administrator. We hope to see you soon with us.</p>');
            $("#thank_btn").html('Close');
          }else{
            $("#thanku").html('<h2>Waad ku</h2><span>mahadsan tahay soo gudbintaada.</span><div class="clr25"></div><p>Dalabkaaga wuxuu ansixin ka sugayaa maamulka <br/>BD. Waxaan kuu rajeyneynaa in si deg deg ah laguugu aqbalo.</p>');
            $("#thank_btn").html('Xir');
          }
          $("#myModal").modal()
        }
      }else{
         ToastsStore.error(nextProps.otp.req_message);
      }
      
    }
    if(nextProps.resend != this.props.resend){
      if(nextProps.resend.req_status == true){
        ToastsStore.success(nextProps.resend.req_message);
      }else{
        ToastsStore.error(nextProps.otp.req_message);
      }

    }
    if(nextProps.evc != this.props.evc){
      this.closeevcModal();
      let languagelist = getlanguagelist();
      if(Object.keys(nextProps.evc).length == 0){
          ToastsStore.error(languagelist.evcwalletfailure);
      }else{
          ToastsStore.success(languagelist.evcwalletsuccess);
          localStorage.setItem('login', 1);
          this.props.history.push(pathList.feed.path);
      }
      
    }
  }

  onOtpSubmit(emailotp){
    
    let param = {
      membership  : '',//this.state.membership,
      user_id     : this.state.user_id,
      otp         : emailotp,
    }
    /* if(this.state.membership == 'GOLD'){
      Object.assign(param, {
        email_otp : emailotp
      })
    } */
    this.props.otoVerification(param);
  }

  onOtpClose(){
    
    this.setState({
      otpmodal    : false
    })
   
  }
  resend(type){
    if(type == 'mobile'){
      let param = {
        phone  : this.state.phone
      }
      this.props.resendotpRequest(param);
    }else{
      let param = {
        email  : this.state.email
      }
      this.props.resendemailotpRequest(param);
    }
  }
  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  onPaymentoptSubmit(opt){
    if(opt == 'PAYPAL'){
      const userdetails  = sessionStorage.getItem('userDetails') || localStorage.getItem('userDetails');
      let userdetailsArr = JSON.parse(userdetails);
      window.location.href = userdetailsArr.payment_url; 
    }else if(opt == 'EVC_WALLET'){
      this.onPaymentoptmodelClose();
      this.openevcModal();
    }
  }
  onPaymentoptmodelOpen(){
    this.setState({
      paymentoptmodal : true
    })
  }
  onPaymentoptmodelClose(){
    this.setState({
      paymentoptmodal : false
    })
  }
  openevcModal(){
    this.setState({
      evcmodal : true
    })
  }
  closeevcModal(){
    this.setState({
      evcmodal : false
    })
  }
  evcpayment(phone){
    let param = {
      reference_id     : '',
      payment_reason   : 'REGISTRATION',
      phone_no         : `252${phone}`
    }
    this.props.evcwalletPayment(param);  

  }
  render() {
    let languagelist = this.props.currentlanguagelist || {};
    return (
    <div>
      <form id="signin-form" onSubmit={this.onSubmit}>
        <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_CENTER} lightBackground />
        <div className="login_box">
          <div className="input-icon">
            <img className="icon" src="./assets/images/input_user_icon.png"/>
            <input type="text" name="username" onChange={this.handleChange} placeholder={`${languagelist.email} / ${languagelist.mobile}`} required />
          </div>
          <div className="input-icon">
            <img className="icon" src="./assets/images/user_password_icon.png"/>
            <input type="password" name="password" onChange={this.handleChange} placeholder={languagelist.password} required/>
          </div>
          <button className="user_login_btn" type="submit">{languagelist.login}</button>
          <p className="text-center forget_password">
            <a href="#">{`${languagelist.forgetpassword}?`}</a>
          </p>
        </div>
      </form>

      <VerifyOtp 
        otpmodal        = {this.state.otpmodal} 
        onOtpSubmit     = {this.onOtpSubmit} 
        onOtpClose      = {this.onOtpClose} 
        resend          = {this.resend} 
        url_membership  = {this.state.membership}
      />

      <PaymentOption 
        paymentoptmodal             = {this.state.paymentoptmodal} 
        onPaymentoptSubmit          = {this.onPaymentoptSubmit} 
        onPaymentoptmodelClose      = {this.onPaymentoptmodelClose} 
      />
      <WalletConnection 
          modalOpen={this.state.evcmodal} 
          closeModal={this.closeevcModal} 
          evcpayment={this.evcpayment}
      />         
    </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    stateNames          : state.signup,
    currentUserDetails  : state.login,
    currentlanguage     : state.currentlanguage.currentlanguage.language,
    currentlanguagelist : state.currentlanguage.currentlanguage.languagelist,
    otp                 : state.verifyotp.verifyOtp,
    resend              : state.resendotp.resendOtp,
    evc                 : state.wallet.walletReply
  }
}

const mapDispatchToProps = dispatch => {
  return {
    createLoginRequest       : bindActionCreators(createLoginRequest , dispatch),
    otoVerification          : bindActionCreators(otoVerification, dispatch),  
    resendemailotpRequest    : bindActionCreators(resendemailotpRequest, dispatch),
    resendotpRequest         : bindActionCreators(resendotpRequest, dispatch),    
    evcwalletPayment         : bindActionCreators(evcwalletPayment, dispatch),
  }
}

Form.propTypes = {
  createLoginRequest: PropTypes.func.isRequired,
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Form));